/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionAnswersRequest
 */
export interface QuestionAnswersRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionAnswersRequest
     */
    question: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionAnswersRequest
     */
    answers: Array<string>;
}

/**
 * Check if a given object implements the QuestionAnswersRequest interface.
 */
export function instanceOfQuestionAnswersRequest(value: object): value is QuestionAnswersRequest {
    if (!('question' in value) || value['question'] === undefined) return false;
    if (!('answers' in value) || value['answers'] === undefined) return false;
    return true;
}

export function QuestionAnswersRequestFromJSON(json: any): QuestionAnswersRequest {
    return QuestionAnswersRequestFromJSONTyped(json, false);
}

export function QuestionAnswersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionAnswersRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'question': json['question'],
        'answers': json['answers'],
    };
}

export function QuestionAnswersRequestToJSON(value?: QuestionAnswersRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'question': value['question'],
        'answers': value['answers'],
    };
}

